import { render } from "./weekNavigator.vue?vue&type=template&id=2ed321ce&ts=true"
import script from "./weekNavigator.vue?vue&type=script&lang=ts"
export * from "./weekNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__